import { render, staticRenderFns } from "./TaskCheckbox.vue?vue&type=template&id=26490a37&scoped=true&"
import script from "./TaskCheckbox.vue?vue&type=script&lang=js&"
export * from "./TaskCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TaskCheckbox.vue?vue&type=style&index=0&id=26490a37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26490a37",
  null
  
)

export default component.exports